import { render, staticRenderFns } from "./MiniTable.vue?vue&type=template&id=650a5a82"
import script from "./MiniTable.vue?vue&type=script&lang=js"
export * from "./MiniTable.vue?vue&type=script&lang=js"
import style0 from "./MiniTable.vue?vue&type=style&index=0&id=650a5a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports